import { Button, Col, Modal, Row, Spin, Table, Tag, Tooltip } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { Constant } from '../../../config';
import { GatewayColor, GatewayName } from '../../../config/gateway';
import MyModal from '../../Modal';
import SendersDefaultForm from '../../Senders/default-form';
import SearchForm from '../../Senders/search-form';

const modalName = 'senders';

class SendersModal extends Component {
  state = {
    loading: false,

    countryList: [],
    currentCountryAbbr: 'ALL',
    currentGatewayID: -1,
    currentPage: 1,
    currentSearch: '',
    dataSource: [],
    gatewayList: [],
    totalRows: 0,
    sendersPoolList: [],

    current_data: {
      id: 0,
      senders_pool_id: undefined,
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
  };

  columns = [
    {
      align: 'center',
      dataIndex: 'created_date',
      render: (created_date) => {
        if (!created_date) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created_date}
          </Moment>
        );
      },
      title: 'วัน / เวลา สร้าง',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'gateway_id',
      render: (_, record) => {
        return this.getGatewayTag(
          record.gateway_detail ? record.gateway_detail.key_name || '' : '',
        );
      },
      title: 'Gateway',
      width: '200px',
    },
    {
      align: 'center',
      dataIndex: 'country_abbr',
      render: (country_abbr) => {
        return this.getCountryAbbrTag(country_abbr || '');
      },
      title: 'ประเทศ',
      width: '100px',
    },
    {
      align: 'center',
      dataIndex: 'sender',
      title: 'Sender',
      width: '200px',
    },
    {
      align: 'center',
      dataIndex: 'is_default',
      render: (isDefault, record) => {
        if (typeof isDefault !== 'boolean' || !isDefault) return '-';

        return <Tag color="blue">Default</Tag>;
      },
      title: 'Default',
      width: '100px',
    },
    {
      align: 'center',
      dataIndex: 'updated_date',
      render: (updated_date) => {
        if (!updated_date) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {updated_date}
          </Moment>
        );
      },
      title: 'วัน / เวลา แก้ไข ล่าสุด',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'id',
      render: (id, record) => {
        if (typeof id === 'undefined') return '-';

        const countryAbbr = record.country_abbr || '';
        const gatewayKenName = record.gateway_detail
          ? record.gateway_detail.key_name || ''
          : '';
        const sender = record.sender || '';

        return (
          <div>
            <Tooltip placement="top" title="แก้ไข">
              <Button
                icon="edit"
                onClick={() => this.edit(record || undefined)}
                style={{ marginRight: '5px' }}
              />
            </Tooltip>
            <Tooltip placement="top" title="ลบ">
              <Button
                type="danger"
                icon="delete"
                onClick={() => this.delete(id, sender, gatewayKenName, countryAbbr)}
              />
            </Tooltip>
          </div>
        );
      },
      title: 'ดำเนินการ',
    },
  ];
  limit = 20;

  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d } = this.props;

    if (
      d &&
      d.memberId &&
      typeof d.memberId !== 'undefined' &&
      d.memberId !== pd.memberId &&
      d.modalName === modalName
    ) {
      this.setState({ loading: true });

      const propsCountryList = JSON.parse(JSON.stringify(this.props.countryList || []));

      if (propsCountryList.length > 0) {
        propsCountryList[0].region_code = 'ALL';
        propsCountryList[0].name = 'ทั้งหมด';
      }

      const tmpPropsGatewayList = JSON.parse(
        JSON.stringify(this.props.gatewayList || []),
      );
      let propsGatewayList = [];

      if (tmpPropsGatewayList.length > 0) {
        propsGatewayList = [{ id: -1, name: 'ทั้งหมด' }].concat(tmpPropsGatewayList);
      }

      await this.getDataList();

      this.setState({
        countryList: propsCountryList,
        gatewayList: propsGatewayList,
        loading: false,
      });
    }
  };

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(
      page,
      this.state.currentSearch,
      this.state.currentCountryAbbr,
      this.state.currentGatewayID,
    );

    this.setState({ loading: false });
  };

  create = async () => {
    this.setState({
      loading: true,
      // sendersPoolList: await this.getSendersPoolList(),
    });

    this.setState({
      current_data: {
        id: 0,
        senders_pool_id: undefined,
      },
      loading: false,
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  delete = (id = 0, sender = '', gatewayKeyName, countryAbbr) => {
    if (!id) return 0;

    MyModal.confirm(
      'ต้องการลบรายการนี้ ใช่หรือไม่ ?',
      <span>
        {this.getGatewayTag(gatewayKeyName)}
        {this.getCountryAbbrTag(countryAbbr)}
        {sender || '-'}
      </span>,
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios({
            url: `${Constant.SENDERS_API}/${id}`,
            method: 'DELETE',
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
            },
          });

          MyModal.success('ลบรายการสำเร็จ');
        } catch (e) {
          console.log(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
        }

        await this.changePage(this.state.currentPage);
        this.setState({ loading: false });
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  edit = async (d) => {
    if (!d) return 0;
    if (!d.id || !d.sender) return 0;

    this.setState({
      loading: true,
      sendersPoolList: await this.getSendersPoolList(d.senders_pool_id || undefined),
    });

    this.setState({
      current_data: {
        id: d.id,
        senders_pool_id: d.senders_pool_id,
      },
      flagCreateOrUpdateForm: false,
      loading: false,
      visibleFormModal: true,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;
    const memberID = this.props.data.memberId;

    if (!memberID) return;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        'ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?',
        '',
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const token = localStorage.getItem(Constant.SessionKey);
          let method = 'PATCH';
          let url = `${Constant.SENDERS_API}/${values.id}`;

          if (this.state.flagCreateOrUpdateForm) {
            method = 'POST';
            url = Constant.SENDERS_API;
          }

          const fd = {
            ...values,
            member_id: memberID,
          };

          const opt = {
            data: fd,
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            method,
            url,
          };

          try {
            await axios(opt);

            if (this.state.flagCreateOrUpdateForm) form.resetFields();

            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, '', async () => {
              await this.getDataList();

              this.setState({
                current_data: {
                  id: 0,
                  senders_pool_id: 0,
                },
                flagCreateOrUpdateForm: true,
                loading: false,
                sendersPoolList: await this.getSendersPoolList(),
                visibleFormModal: false,
              });
            });
          } catch (e) {
            let eMsgDetail = '';

            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ''}] ${tmp.name || ''}`;
            }

            MyModal.error(errorMsg, eMsgDetail, () => window.location.reload());
          }
        },
        'ยืนยัน',
        'ยกเลิก',
      );
    });
  };

  formHandleCancel = () => {
    this.setState({
      current_data: {
        id: 0,
        senders_pool_id: undefined,
      },
      visibleFormModal: false,
    });
  };

  getCountryAbbrTag = (country = '') => (
    <Tag color="brown" style={{ fontWeight: 'bold' }}>
      {country || '-'}
    </Tag>
  );

  getDataList = async (page = 1, search = '', country_abbr = 'ALL', gateway_id = -1) => {
    const memberID = this.props.data.memberId;

    if (!memberID) return;

    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        page,
        limit: this.limit,
        gateway_id,
        country_abbr,
        search,
        status: 'enabled',
        member_id: memberID,
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getGatewayTag = (gateway = '') => (
    <Tag color={GatewayColor(gateway)}>{GatewayName(gateway)}</Tag>
  );

  getSendersPoolList = async (sendersPoolID) => {
    const memberID = this.props.data.memberId;

    if (!memberID) return;

    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_POOL_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        filter_out_used: memberID,
        id: sendersPoolID,
        sendersPoolID,
        page: 1,
        limit: 3000,
        status: 'enabled',
        member_id: memberID,
      },
      url,
    };

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentCountryAbbr = values.country_abbr || 'ALL';
      const currentGatewayID = values.gateway_id || -1;
      const currentPage = 1;
      const currentSearch = values.searchTxt || '';

      this.setState({
        currentCountryAbbr,
        currentGatewayID,
        currentPage,
        currentSearch,
        loading: true,
      });

      await this.getDataList(
        currentPage,
        currentSearch,
        currentCountryAbbr,
        currentGatewayID,
      );

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({ loading: true });

    await this.getDataList(1);

    this.setState({
      currentCountryAbbr: undefined,
      currentGatewayID: undefined,
      currentPage: 1,
      currentSearch: undefined,
      loading: false,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  render() {
    const { data, onCancel, visible } = this.props;
    const memberID = data ? data.memberId || '-' : '-';
    const memberName = data ? data.memberName || '-' : '-';
    const propsTable = {
      bordered: true,
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      size: 'small',
      scroll: {
        x: 800,
      },
    };

    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = 'my-table-mobile';
    propsTableForMobile.columns = this.columns;

    let title = `Sender ของ ${memberName} (MBR${memberID})`;

    return (
      <Modal
        className="my-layout"
        footer={[
          <Button key="cancel" onClick={onCancel}>
            ปิด
          </Button>,
        ]}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        visible={visible}
        width={1200}
      >
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Row className="utility-bar">
            <Col span={6}>
              <Button icon="plus-circle" onClick={() => this.create()}>
                เพิ่ม
              </Button>
            </Col>
            <Col span={18}>
              <SearchForm
                countryList={this.state.countryList}
                gatewayList={this.state.gatewayList}
                fn={this.mySearch}
                fnReset={this.resetSearch}
              />
            </Col>
          </Row>
          <Row className="utility-bar-mobile">
            <Button icon="plus-circle" onClick={() => this.create()}>
              เพิ่ม
            </Button>
          </Row>
          <Row className="utility-bar-mobile">
            <SearchForm
              countryList={this.state.countryList}
              gatewayList={this.state.gatewayList}
              fn={this.mySearch}
              fnReset={this.resetSearch}
            />
          </Row>
          <Table {...propsTable} />
          <Table {...propsTableForMobile} />
        </Spin>
        <SendersDefaultForm
          loading={this.state.loading}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          sendersPoolList={this.state.sendersPoolList}
          visible={this.state.visibleFormModal}
          wrappedComponentRef={this.saveFormRef}
          getGatewayTag={this.getGatewayTag}
          getCountryAbbrTag={this.getCountryAbbrTag}
        />
      </Modal>
    );
  }
}

export default SendersModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/senders.modal.js